module.exports = __webpack_public_path__ + "img/cross-boards.0321cd2b.svg";